<template lang="pug">
	div.doc-list-wrapper(@drop.prevent="onDrop", :class="{'drag-over':dragOver}", @dragover.prevent="onDragOver",
		@dragleave="onDragLeave")
		span.upload-spinner(v-if="busy")
			OvBusySpinner(:size="40")
		table.doc-list
			tbody
				tr(v-for="(f, index) in files", :key="index")
					td.col-name
						input.form-control(type="text", v-model="f.name")
					td.actions
						a.link-view(target="_blank", :href="f.full_path")
							i.la.la-search
						a.link-remove(href="javascript:void(0);", @click="removeFile(f, index)",
							v-tooltip="f.filename")
							i.la.la-times
		div.add-file(v-if="!single || files.length < 1")
			i.la.la-plus
			input(type="file", ref="file", accept=".xlsx", multiple, v-on:change="handleSelectFile()")
</template>

<style lang="scss">
.doc-list-wrapper {
	width: 100%;
	max-width: 100%;
	position: relative;
	margin-bottom: 20px;

	&:after {
		position: absolute;
		left: 0;
		content: " ";
		right: 0;
		top: 0;
		bottom: 0;
		z-index: 1;
		background: rgba(0, 0, 0, 0);
		transition: background 0.2s ease-in-out;
		pointer-events: none;
	}

	&.drag-over {
		border: 2px dashed #aaa;

		&:after {
			background: rgba(0, 0, 0, 0.4);
		}
	}

	table.doc-list {
		width: 100%;
		border: none;

		td.col-name {
			width: 100%;

			.form-control {
				height: 30px;
			}
		}

		td.actions {
			white-space: nowrap;

			a {
				width: 30px;
				height: 30px;
				line-height: 30px;
				display: inline-block;
				text-align: center;
				padding: 0;
				border-radius: 5px;
				background: #f6f6f6;
				margin: 0 1px;
				color: #aaa;
			}
		}
	}

	.upload-spinner {
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		z-index: 2;
		background: rgba(248, 249, 251, 0.9);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.add-file {
		width: 100%;
		height: 30px;
		line-height: 30px;
		border-radius: 5px;
		background: #eee;
		position: relative;
		text-align: center;
		font-size: 24px;
		cursor: pointer;
		overflow: hidden;

		&:hover {
			background: #ddd;
		}

		input {
			opacity: 0;
			position: absolute;
			inset: 0;
			width: 100%;
			cursor: pointer;
		}
	}
}
</style>

<script>
import http from "@/api/http";

export default {
	name: "DocList",
	props: {
		files: Array,
		single: null,
		cb: null,
		type: String,
		metadata: Object,
		uploadPath: String,
	},
	data() {
		return {
			busy: 0,
			dragOver: false,
		};
	},
	methods: {
		onDrop(e) {
			const droppedFiles = e.dataTransfer.files;
			if (!droppedFiles?.length) return;
			[...droppedFiles].forEach((f) => this.uploadFile(f));
		},
		onDragOver() {
			this.dragOver = true;
		},
		onDragLeave() {
			this.dragOver = false;
		},
		removeFile(f, index) {
			this.files.splice(index, 1);
		},
		handleSelectFile() {
			const droppedFiles = this.$refs.file.files;
			if (!droppedFiles?.length) return;
			[...droppedFiles].forEach((f) => this.uploadFile(f));
		},
		async uploadFile(f) {
			const uploadPath = this.uploadPath || "general/uploadFile";
			const formData = new FormData();
			formData.append("file", f);
			if (this.type) formData.append("type", this.type);
			if (this.metadata) formData.append("metadata", JSON.stringify(this.metadata));

			try {
				this.busy++;
				const resp = await http.post(uploadPath, formData, {
					headers: { "Content-Type": "multipart/form-data" },
				});

				if (resp.data.err) {
					throw new Error(resp.data.errdesc);
				}

				const file = {
					name: resp.data.data.original_name,
					filename: resp.data.data.filename,
					full_path: resp.data.data.full_path,
					type: this.type,
				};
				if (this.cb) {
					this.cb(file);
				}
				this.files.push(file);
			} catch (e) {
				this.$ovNotify.error(e.message || e);
			}
			this.dragOver = false;
			this.busy--;
		},
	},
};
</script>
